export default "__VITE_ASSET__BeAg1zQp__"